import { takeLatest, takeEvery } from 'redux-saga/effects';

import {
  SEARCH_ENTITIES,
  SEARCH_INSTRUMENTS,
  SEARCH_RATING_NEWS,
  SEARCH_RESEARCH,
} from './searchResultActions';
import {
  searchEntitiesSaga,
  searchInstrumentsSaga,
  searchRatingNewsSaga,
  searchResearchSaga,
} from './searchResultSaga';

export function* searchResultWatchers() {
  yield takeEvery(SEARCH_ENTITIES, searchEntitiesSaga);
  yield takeLatest(SEARCH_INSTRUMENTS, searchInstrumentsSaga);
  yield takeLatest(SEARCH_RATING_NEWS, searchRatingNewsSaga);
  yield takeLatest(SEARCH_RESEARCH, searchResearchSaga);
}
